<template>
	<div class="hoslist">
		<div class="hos_top" v-show="selectCity">
			<div class="select_city" @click="showPopup">
				<div class="city">
					<img src="../assets/location.svg" alt />
					<span class="cityNameText">{{selectProName}}</span>
				</div>
			</div>
			<div class="search">
				<form action="/" @click="SearchFocus">
					<van-search placeholder="请输入搜索关键词"/>
				</form>
			</div>
		</div>

		<div class="hos_top1" v-show="searchCity">
			<div class="search">
				<form action="/">
					<van-search v-model="keyword" placeholder="请输入搜索关键词" @search="onsearch" show-action @cancel="onCancel" @input="oninput" />
				</form>
			</div>
			<!-- 搜索出来的医院 -->
			<div v-if="hosListShow">
				<ul class="hosList">
					<li v-for="(item,index) in hosResultList" :key="'hosResultList' + index" @click="goHome(item.hosId)" >{{item.name}}</li>
				</ul>
			</div>
			<!-- <h2 v-if="isShowTip" class="noHosName">没有搜索到匹配结果</h2> -->
		</div>
		<!-- 推荐医院列表弹框 -->
		<div>
			<van-popup v-model="show" position="left" :style="{ height: '100%',width:'80%'}">
				<!-- 推荐医院省份 -->
				<div class="city-title">
					<img class="imageLocation" src="../assets/location.svg" alt />
					<span style="font-weight:bold;margin-left:5px">{{selectProName}}</span>
					<span style="font-size:12px;color:#c0c0c0">(当前位置)</span>
					<van-divider style="margin:16px 0 0 0; border-color: red" />
				</div>
				<!-- 医院省份 -->
				<div class="city-list" v-for="(item,index) in hospitaldata" :key="'hospitalsName'+index" @click="provinceSelect(item,index)">
					<div class="city-list_item">
						<div class="city-list_item_name">
							<span>{{item.province}}</span>
							<img class="logo_after" v-if="item.type == 2?true:false" src="../assets/reommend.svg" alt="">
							<img class="logo_after" v-if="item.type == 3?true:false" src="../assets/hot.svg" alt="">
							<!-- <img class="logo_after" v-if="item.type == 4?false:true" src="" alt=""> -->
						</div>
					</div>
					<van-divider style="margin:0" />
				</div>
			</van-popup>
		</div>
		<!-- 医院列表展示区 -->
		<div class="hos_list" v-if="hosShow">
				<div class="hoslist_item" v-for="(item) in hospitalVos" :key="item.index" @click="hosSelect(item.hosId)">
					<div class="item_img">
						<img :src="item.hosLogoUrl" alt />
					</div>
					<div class="item_content">
						<div class="hos_name hos_name_type">
							<!-- 石家庄市妇产医院(市第四医院)东院区 -->
							{{item.hospitalPreName!=null?item.hospitalPreName:""}}
						</div>
						<div class="hos_name hos_name_type">
							<!-- 石家庄市妇产医院(市第四医院)东院区 -->
							{{item.hospitalPostName!=null?item.hospitalPostName:""}}
						</div>
						<div class="hos_item_type">
							<div v-for="(item,index) in item.hBusinessLevelTwo" :key="index">
								<span class="expressType1">{{item.name}}</span>
							</div>
							<div v-for="(item,index) in item.hBusinessLevelThree" :key="'type2'+index">
								<span class="expressType2">{{item.name}}</span>
							</div>
						</div>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Search,
		Popup,
		Card,
		Divider,
		List,
		Toast
	} from "vant";
	Vue.use(Search)
		.use(Popup)
		.use(Card)
		.use(Divider)
		.use(List)
		.use(Toast);
	export default {
		name: "HosList",
		// inject:['reload'],
		data() {
			return {
				hosId: '',
				input2: "",
				input3: "",
				keyword: "",
				hosList: [],
				hosResultList: [],
				isShowTip: false, //搜索不到数据时显示的文字
				// loading:false,
				// finished:false,
				// showPro:false,
				selectCity: true,
				searchCity: false,
				//   picFocusStatus : true,
				isShowCity: false,
				show: false,
				hosShow: true,
				hosListShow: false,
				selectProName: '',
				hospitalsName: [],
				hospitaldata: [],
				hospitalVos: [],
				ceshi: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
					'20', '21'
				],
				timer:''
			};
		},
		created() {
			
			// let areaId = this.$route.params.areaId;
			let areaId = localStorage.getItem("areaId");
			console.log(areaId,'这是areaId')
			let wxId = localStorage.getItem("wxId");
			let userId = localStorage.getItem("userId");
			console.log(wxId,userId)
			const params = {
				wxId: wxId,
				userId: userId,
				areaId:areaId,
			};
			this.hosListRequest(params);
			
		},
		mounted() {
		},
		methods: {
			getHosListRequest(paramsList){
				this.$server.hosListRequest(paramsList).then(data =>{
					if(data.result == 1){
						console.log(data)
						this.hosResultList = data.hospitals
						console.log('全部医院名称')
					}
				})
			},
			hosListRequest(params) {
				this.$server.hosListRequest(params).then(data => {
					if (data.result == 1) {
						this.hospitaldata = data.hospitals;
						console.log(data.hospitals)
						this.selectProName = this.hospitaldata[0].province
						this.hospitalVos = this.hospitaldata[0].hospitalVos
						localStorage.removeItem("areaId");
					} else if (data.result == 200) {
						console.log("2");
					}
				});
			},
			provinceSelect(item,index) {
				console.log(item,index)
				// this.selectProName = '测试省'
				console.log('1111111')
				this.selectProName =item.province
				console.log(this.selectProName)
				this.hospitalVos = item.hospitalVos
				console.log(this.hospitalVos)
				// this.hospitalparams = this.hospitaldata[index].hospitalparams;
				// this.selectProName = '山西省'
				// this.selectProName = this.hospitalsName[index];
				// console.log(this.selectProName+'1');
				// console.log(this.selectProName)
				this.show = false;
				// this.reload();
			},
			hosSelect(hosId) {
				localStorage.setItem("hosId", hosId);
				// this.$router.push({
				// 	path: '/apply',
				// 	query: {
				// 		hosId: hosId
				// 	}
				// })
				localStorage.setItem('hosId',hosId)
				this.$router.push('/apply/' + hosId + '/' + '-1')
		
			},
			SearchFocus() {
				this.selectCity = false;
				this.searchCity = true;
				this.hosShow = false;
				this.hosListShow = true;
			},
			onsearch() {
				// console.log('正在搜索')

				if (this.keyword == '') {
					console.log('啥也没输入')
					return
				}
				// this.hosResultList = []
				// this.hosList.forEach((item) => {
				// 	if ((item.name).indexOf(this.keyword) > -1) {
				// 		this.hosResultList.push(item)
				// 	}
				// })
				
				if (this.hosResultList.length == 0) {
					console.log('没有这个医院')
					Toast.success('没有搜到相关医院');
					// this.isShowTip = true
				}
			},
			oninput(){
				// console.log('输入框有变化')
				// if (this.keyword == '') {
				// 	console.log('啥也没输入')
				// 	return
				// }
				// 
			let wxId = localStorage.getItem("wxId");
			let userId = localStorage.getItem("userId");
			let	paramsList = {
				'wxId':wxId,
				'userId':userId,
				'word':this.keyword,
			};
			this.getHosListRequest(paramsList);
			console.log(this.keyword)
			
			
				// if (this.timer) {
        		// 	clearTimeout(this.timer)
				//    }
				//  this.timer = setTimeout(() => { 
				// 	 this.hosResultList = []
				// 	this.hosList.forEach((item) => {
				// 	// if(this.keyword!=''&&((item.name).indexOf(this.keyword)>-1))
				// 	if(this.keyword!=''&& ((item.name).indexOf(this.keyword) > -1)) {
				// 		this.hosResultList.push(item)
				// 		}
				// 	})
				//  },100)  
					
					
				// if (this.hosResultList.length == 0) {
				// 	console.log('没有这个医院')
				// 	Toast.success('没有搜到相关医院');
				// 	// this.isShowTip = true
				// }

			},
			onCancel() {
				console.log("onCancel");
				this.selectCity = true;
				this.searchCity = false;
				this.hosShow = true;
				this.hosListShow = false;
			},
			goHome(hosId){
				localStorage.setItem("hosId", hosId);
				// this.$router.push({
				// 	path: '/apply',
				// 	query: {
				// 		hosId: hosId
				// 	}
				// })
				this.$router.push('/apply/' + hosId + '/' + '-1')
			},
			showPopup() {
				this.show = true;
			}
		}
	};
</script>

<style>
	.hoslist {
		width: 100%;
		height: 100vh;
		background: #f5f8fa;
	}
	.hos_name_type{
		text-align: left !important;
	}
	.hos_top {
		display: flex;
		/* background: white; */
		height: 54px;
	}

	.select_city {
		flex: 5;
		background: #ffffff;
		/* background:yellow; */
	}

	.noHosName {
		font-size: 18px;
		color: #666666;
		width: 100%;
		margin: 30px auto;
		text-align: center;
	}

	.city {
		background-color: rgb(247, 248, 250);
		margin: 10px 0px 10px 10px;
		color: #007aff;
		font-weight: bold;
		border-radius: 2px;
		font-size: 15px;
		/* width: 100%; */
		height: 34px;
	}

	.city img {
		width: 20px;
		height: 20px;
		margin: 8px 6px;
	}

	.search {
		flex: 10;
		background: #f5f8fa;
	}

	.cityNameText {
		width: 52px;
		color: #007aff;
		font-size: 14px;
		display: inline-block;
		vertical-align: middle;
		letter-spacing: 3px;
		line-height: 38px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-bottom:28px;
	}

	.city:after {
		content: " ";
		display: inline-block;
		height: 7px;
		width: 7px;
		border-width: 1px 1px 0 0;
		border-color: #007aff;
		border-style: solid;
		-webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		/*position: relative;*/
		/*top: -2px;*/
		position: absolute;
		top: 18px;
		margin-top: 7px;
		vertical-align: middle;
	}

	.search {
		flex: 10;
	}

	.hos_list {
		margin: 5px 0;
	}

	.hoslist_item {
		/* width: 100%; */
		/* height: 70px; */
		background-color: white;
		padding: 10px 15px;
		display: flex;
		border-bottom: 1px solid #eeeeee;
	}

	.item_img {
		flex: 2;
		margin-top: 16px;
	}

	.item_img img {
		width: 50px;
		height: 50px;
	}

	.item_content {
		flex: 9;
		margin-top: 10px;
		/* display: flex; */
	}

	.hos_item_type {
		padding-bottom: 12px;
		display: flex;
		display: -webkit-flex;
		/* Safari */
		margin-top: 5px;
		margin-left: -5px;
		flex-wrap: wrap;
	}

	.expressType2 {
		border: 1px solid #ff8605;
		color: #ff8605;
		font-size: 10px;
		line-height: 1.5;
		text-align: center;
		margin-left: 5px;
		border-radius: 2px;
		padding-left: 3px;
		padding-right: 3px;
		margin: 5px;
		display: inline;
	}

	.expressType1 {
		border: 1px solid #1aad19;
		color: #1aad19;
		font-size: 10px;
		line-height: 1.5;
		text-align: center;
		margin-left: 5px;
		border-radius: 2px;
		padding-left: 3px;
		padding-right: 3px;
		margin: 5px;
		display: inline;
	}

	.city-title {
		float: left;
		padding: 10px 0 0 10px;
		font-size: 16px;
		width: 100%;
		/* margin-left: 10px; */
	}

	.imageLocation {
		width: 15px;
		height: 15px;
		display: inline-block;
		vertical-align: middle;
		/* margin-right: 3px; */
		margin-left: 5px;
	}

	.city-list {
		background-color: #fff;
		line-height: 1.47058824;
		font-size: 17px;
		overflow: hidden;
		position: relative;
		width: 100%;
		margin-left: 10px;
	}

	.city-list_item {
		padding: 10px 15px;
		position: relative;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		/*-webkit-box-align: center;*/
		/*-webkit-align-items: center;*/
		/*align-items: center;*/
	}

	.city-list_item:after {
		content: " ";
		display: inline-block;
		height: 7px;
		width: 7px;
		border-width: 2px 2px 0 0;
		border-color: #c8c8cd;
		border-style: solid;
		-webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position: relative;
		top: -5px;
		position: absolute;
		top: 50%;
		margin-top: -5px;
		right: 35px;
	}

	.city-list_item_name {
		margin-left: 30px;
	}


	.hosList li {
		line-height: 50px;
		border-bottom: 1px solid #eeeeee;
		margin-left: 40px;
	}
	.logo_after {
  		width: 30px;
 		 height: 22px;
	}
</style>
